import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';

export const SEARCH_DEBOUNCE_MS = 300;

/**
 * HipSearchBox — free-text filter (name / UHID / mobile). Calls onSearch(trimmedText)
 * once, SEARCH_DEBOUNCE_MS after typing stops, and only when the value actually changed
 * (never on mount). onSearch must be a stable setter (state setter).
 */
export default function HipSearchBox({ label, onSearch }) {
  const { isDark } = useTheme();
  const [text, setText] = useState('');
  const lastSent = useRef('');

  useEffect(() => {
    const t = setTimeout(() => {
      const v = text.trim();
      if (v !== lastSent.current) {
        lastSent.current = v;
        onSearch(v);
      }
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [text, onSearch]);

  return (
    <input
      type="search"
      aria-label={label}
      placeholder="Search by name, UHID or mobile"
      value={text}
      onChange={(e) => setText(e.target.value)}
      style={{
        flex: '1 1 220px', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box',
        background: isDark ? '#1e293b' : '#ffffff',
        color: isDark ? '#f1f5f9' : '#111827',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : '#d1d5db'}`,
        borderRadius: 6, padding: '6px 8px', fontSize: 13,
      }}
    />
  );
}
